import { gsap } from 'gsap/dist/gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export function buttonScrollDown() {

  const scrollButton = document.querySelector('[data-scroll-down]')
  const targetElement = document.querySelector('[data-scroll-to]')
  
  if (scrollButton && targetElement) {
    const offset = targetElement.dataset.offset ? targetElement.dataset.offset : 50

    scrollButton.addEventListener('click', () => {
      gsap.to(window, {scrollTo: { y: targetElement, offsetY: offset }, duration: 2, ease: 'power2.inOut', overwrite: true});
    })
  }
}


// WEBPACK FOOTER //
// ./scripts/animation/button-scroll-down.js